

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Typography,
  Box,
  IconButton,
  Tooltip,
  Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControl, InputLabel, Select, MenuItem,
  Divider
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Edit, Delete, ArrowBack, MoveToInbox, AddBox, } from "@mui/icons-material";
import apiService from "../../service/apiService";
import { CheckCircle } from "@mui/icons-material";
import { SiCoinmarketcap } from "react-icons/si";

import Add from "@mui/icons-material/Add";


const ChildProduction = () => {
  const location = useLocation();
  const rowData = location.state?.data; 
  console.log("rowdata from first", rowData);
  const navigate = useNavigate();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [productionData, setProductionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    tlSeed: '',
    consumption: '',
    sellQuantity: '',
    salePrice: '',
    basePrice: '',
    cropProductionId: "",
    productionQuantity: "",
    marketTypeId:'',
    name:'',
    location:''
  });
  const [warning, setWarning] = useState('');
  const [error, setError] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
    const initialFormData = {
    tlSeed: '',
    consumption: '',
    sellQuantity: '',
    salePrice: '',
    basePrice: '',
  };

  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [addsupplymodal, setAddSupplyModal] = useState(false);
  const [supplyTypes, setSupplyTypes] = useState([]);
  const [selectedSupplyTypes, setSelectedSupplyTypes] = useState([]);
  const [allselectedSupplies, setAllSelectedSupplies] = useState([]);
  const [supplyResponse, setSupplyResponse] = useState([]);
  const [ppchemical, setPPchemical] = useState("");
  const [usedsupplies, setUsedSupplies] = useState([]);
  const [planId, setPlanId] = useState(0);
  const [saletypes, setSaleType] = useState([]);
  const [ismandi, setIsMandi] = useState(false);
  const [verifiedBy, setVerifiedBy] = useState([]);

  const fetchSupplyByTypes = async (ids) => {
    console.log("IDs are:", ids);
    
    let allResponses = [];

    for (const id of ids) {
        try {
            const response = await apiService.get(`/supply/get-supply-by-type/${id}`);
            allResponses.push(...response.data.body); 
            setSupplyResponse([...allResponses]);  
        } catch (error) {
            console.error(`Error fetching supply for ID ${id}:`, error);
        }
    }
};

  useEffect(() => {
    if (Array.isArray(selectedSupplyTypes) && selectedSupplyTypes.length > 0) {
      fetchSupplyByTypes(selectedSupplyTypes);
    }
  }, [selectedSupplyTypes]);

  const handleSelectionChange = (event) => {
    const value = event.target.value;  
      setSelectedSupplyTypes(value); 
  };

  const handleAllSelectionSupplies = (event) => {
    const value = event.target.value;  
    setAllSelectedSupplies(value); 
  };
  const handleDeleteConfirm = async () => {
    if (selectedRow) {
      const cropProductionId = selectedRow.cropProductionId;

      try {
        await apiService.delete(`/crops/delete/${cropProductionId}`);
        console.log(`Deleted crop production with ID: ${cropProductionId}`);
      } catch (error) {
        console.error("Error deleting crop production:", error);
      }
    }

    setOpenDeleteDialog(false); // Close the dialog after deletion
  };
  const handleEditClick = (row) => {
    console.log("Edit clicked for row:", row);
    setSelectedRow(row); // Set the row data to the selectedRow state
    setOpenEditDialog(true); // Open the dialog
  };
  
  const fetchUsedSeeds = async () => {
    try {
      const cropProductionMasterId = rowData.cropProductionMasterId;
      const response = await apiService.get(`/crop-master/get-all-supplies/${cropProductionMasterId}`);
      setUsedSupplies(response.data.body);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    }
  };

  // Handle save action

  const handleSaveEdit = async () => {
    console.log("Save clicked with updated data:", selectedRow);
  
    const { cropProductionId, seedSowingDate, cultivatedArea, productionQuantity } = selectedRow;
  
    if (!cropProductionId) {
      console.error("Error: cropProductionId is required.");
      alert("Crop Production ID is missing.");
      return;
    }
  
    try {
      // Format date
      const formatDate = (date) => {
        if (!date || !date.includes("-")) {
          console.error("Invalid date format:", date);
          throw new Error("Invalid date format");
        }
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year}`;
      };
  
      const formattedSeedSowingDate = formatDate(seedSowingDate);
      const parsedCultivatedArea = parseFloat(cultivatedArea);
  
      const apiUrl = `/crops/update/${cropProductionId}`;
      const payload = {
        seedSowingDate: formattedSeedSowingDate,
        cultivatedArea: parseFloat(parsedCultivatedArea),
        productionQuantity: parseFloat(productionQuantity),
      };
  
      console.log("Payload being sent:", payload);
  
      const response = await apiService.put(apiUrl, payload, {
        headers: { "Content-Type": "application/json" },
      });
  
      console.log("API response:", response.data);
  
      // Success feedback
      alert("Crop details updated successfully!");
      setOpenEditDialog(false);
      fetchProduction();
  
    } catch (error) {
      console.error("Error updating crop details:", error.response || error.message || error);
      alert("Failed to update crop details. Please try again.");
    }
  };
    
  const remainingQuantity =
  (parseFloat(selectedRow?.productionQuantity) || 0) - (parseFloat(formData.sellQuantity) || 0);

  const fetchAllSupplyType = async () => {
    try {
      const response = await apiService.get("/supply/get-all-supply-type");
      setSupplyTypes(response.data);
    } catch (error) {
      console.error("Error fetching seeds:", error);
    }
  };

  useEffect(() => {
    fetchAllSupplyType();
    fetchUsedSeeds();
  }, []);



  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "sellQuantity" && parseFloat(value) > selectedRow.productionQuantity) {
      alert("Sell Quantity cannot exceed Production Quantity.");
      return;
    }

    if (name === "tlSeed" && parseFloat(value) > remainingQuantity) {
      alert("Used TlSeed cannot exceed the remaining quantity.");
      return;
    }

    if (name === "consumption" && parseFloat(value) > remainingQuantity) {
      alert("Consumption cannot exceed the remaining quantity.");
      return;
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSellQuantityChange = (e) => {
    const value = e.target.value;
    if (/^[0-9]*\.?[0-9]*$/.test(value)) {
      if (parseFloat(value) > selectedRow.productionQuantity) {
        alert("Sell Quantity cannot exceed Production Quantity.");
        return;
      }

      setFormData({
        ...formData,
        sellQuantity: value,
        tlSeed: "",
        consumption: "",
      });
    }
  };

  const handleTlSeedChange = (e) => {
    const value = e.target.value;
    if (/^[0-9]*\.?[0-9]*$/.test(value)) {
      if (parseFloat(value) > remainingQuantity) {
        alert("Used TlSeed cannot exceed the remaining quantity.");
        return;
      }

      setFormData({
        ...formData,
        tlSeed: value,
        consumption: (remainingQuantity - parseFloat(value) || 0).toString(),
      });
    }
  };

  const handleConsumptionChange = (e) => {
    const value = e.target.value;
    if (/^[0-9]*\.?[0-9]*$/.test(value)) {
      if (parseFloat(value) > remainingQuantity) {
        alert("Consumption cannot exceed the remaining quantity.");
        return;
      }

      setFormData({
        ...formData,
        consumption: value,
        tlSeed: (remainingQuantity - parseFloat(value) || 0).toString(),
      });
    }
  };

  const handleMarketClick = (row) => {
    // Set selected row and open the dialog
    setSelectedRow(row);
    setPlanId(row.cropPlanId);
    setFormData({
      ...formData,
      cropProductionId: row.cropProductionId, // Pass cropProductionId to the form
    });
    setOpenDialog(true);
  };


  const handleAddClick = (row) => {
    setSelectedRow(row);
    setFormData({
      ...formData,
      cropProductionId: row.cropProductionId, 
    });
    setOpen(true); 
    };

    const handleClose = () => {
      setOpen(false); 
    };
  
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const fetchAllSaleTypes = async () => {
    try {
      const response = await apiService.get(`/market-type/get-by-crop-plan-id/${planId}`);
      setSaleType(response.data.body || []); 
      
    } catch (error) {
      setSaleType([]);
      console.error("Error fetching sale types:", error);
    }
  }

    useEffect(() => {
    if (planId > 0) {
      fetchAllSaleTypes();
    }
  }, [planId]);

  const handleSubmitproduction = async () => {
    try {
      const payload = {
        productionQuantity:parseInt(formData.productionQuantity),
        cropProductionId: formData.cropProductionId,
      };

      console.log("Payload to be sent:", payload);

      const response = await apiService.post("/crops/create-production", payload);
      console.log("API response:", response.data);
      alert("Production added successfully!");
      fetchProduction();
      // Close the dialog on success
      setOpen(false);
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const handleSubmit = () => {
    // Construct the new entry
    const newEntry = {
      cropProductionMasterId: selectedRow.cropProductionMasterId,
      cropProductionId: selectedRow.cropProductionId,
      basePrice: parseFloat(formData.basePrice),
      salePrice: parseFloat(formData.salePrice),
      tlSeed: parseFloat(formData.tlSeed),
      consumption: parseFloat(formData.consumption),
      marketTypeId: parseInt(formData.marketTypeId),
      location: formData.location,
      name: formData.name,
      isMandi: ismandi
    };
  
    console.log("New Entry:", newEntry);
  
    try {
      // Update local storage
      const existingData = JSON.parse(localStorage.getItem("cropData")) || [];
      console.log("Existing Data Before Append:", existingData);
  
      const updatedData = [...existingData, newEntry];
      console.log("Updated Data After Append:", updatedData);
  
      localStorage.setItem("cropData", JSON.stringify(updatedData));
      console.log("Local Storage Data After Save:", localStorage.getItem("cropData"));
  
      // Disable icons for the selected row
      setProductionData((prevData) =>
        prevData.map((row) =>
          row.cropProductionId === selectedRow.cropProductionId
            ? { ...row, isInactive: true }
            : row
        )
      );
  
      // Reset form data and close dialog
      setFormData(initialFormData);
      setWarning('');
      setError('');
      setOpenDialog(false);
    } catch (error) {
      console.error("Error while updating localStorage:", error);
      setError("Failed to save data. Please try again.");
    }
  };
  
  const handleSaveAddSupplies = async () => {
    const cropProductionMasterId = rowData.cropProductionMasterId;
    
    if (!cropProductionMasterId) {
        console.error("Crop Production Master ID is not available");
        alert("Crop Production Master ID is not available.");
        return;
    }

    const requestBody = {
        cropProductionMasterId,
        suppliesUsed: allselectedSupplies,  
        otherSupplies: ppchemical  
    };

    try {
        const response = await apiService.put(`/crop-master/add-supply/${cropProductionMasterId}`, requestBody);
        
        console.log("Supply added successfully:", response.data);
        alert("Supplies added successfully!");
        setAllSelectedSupplies([]);
        setPPchemical("");
        setSelectedSupplyTypes([]);
        setSelectedSupplyTypes(false);
        fetchProduction();
        fetchUsedSeeds();
        setAddSupplyModal(false);

    } catch (error) {
        console.error("Error adding supplies:", error);
        alert("Failed to add supplies. Please try again.");
    }
};


  // Handle cancel action
  const handleCancel = () => {
    setFormData(initialFormData);
    setWarning('');
    setError('');
    setOpenDialog(false);
  };

  const fetchProduction = async () => {
    if (rowData?.cropProductionMasterId) {
      try {
        const response = await apiService.get(`/crops/production/${rowData.cropProductionMasterId}`);
        setProductionData(response.data.body.cropProductionData); 
        setVerifiedBy(response.data.body.verificationLogs[0] || []);
      } catch (err) {
        console.error("Error fetching production data:", err);
        setError("Failed to fetch production data.");
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProduction();
  }, [rowData]);


  const handleBack = () => {
    navigate(-1);
  };

  const handleAddMarketlink = async () => {
    const isConfirmed = window.confirm(
      "Are you sure you want to move to market linkage?"
    );

    // If user cancels, exit the function
    if (!isConfirmed) {
      return;
    }

    try {
      // Retrieve data from localStorage
      const marketLinkages = JSON.parse(localStorage.getItem("cropData")) || [];

      if (!marketLinkages.length) {
        alert("No market linkage data available.");
        return;
      }

      const cropProductionMasterId = marketLinkages[0]?.cropProductionMasterId;

      if (!cropProductionMasterId) {
        alert("No cropProductionMasterId available.");
        return;
      }

      // Construct API payload
      const payload = {
        cropProductionMasterId: cropProductionMasterId,
        marketLinkages: marketLinkages,
      };

      console.log("Payload for API:", payload);

      // API call
      const response = await apiService.post(
        "/market-linkage/create",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("API Response:", response.data);
      alert("Market linkage created successfully!");
      fetchProduction();

      localStorage.removeItem("cropData");
      console.log("Local storage data cleared.");
    } catch (error) {
      console.error("Error while creating market linkage:", error);
      alert("Failed to create market linkage. Please try again.");
    }
  };
  const handleVerify = async () => {
      console.log("Verify button clicked");
  
      const cropProductionMasterId = rowData.cropProductionMasterId;
      if (!cropProductionMasterId) {
          console.error("Crop Production Master ID is not available");
          alert("Crop Production Master ID is not available.");
          return;
      }
  
      try {
        const response = await apiService.put('/crop-master/verify', {
          cropProductionMasterIds: [cropProductionMasterId],
          remarks: "Verified successfully"
        });
  
          console.log("Verification successful:", response.data);
          alert("Verification successful!");
      } catch (error) {
          if (error.response) {
              console.error("Error response:", error.response.data);
              console.error("Status code:", error.response.status);
              alert(`Verification failed: ${error.response.data.message || "An error occurred"}`);
          } else {
              console.error("Error occurred:", error.message);
              alert(`Verification failed: ${error.message}`);
          }
      }
  };
 
  return (
    <Box sx={{ padding: 2, overflowX: "auto" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          justifyContent: "space-between", // This will place items on both sides
        }}
      >
        {/* Back button aligned to the left */}
        <Button
          startIcon={<ArrowBack />}
          onClick={handleBack}
          sx={{
            marginBottom: 2,
            backgroundColor: "#1976d2",
            color: "white",
            "&:hover": { backgroundColor: "#1565c0" },
          }}
        >
          Back
        </Button>

        <Box sx={{ display: "flex", gap: 2 }}>
        <Button
            onClick={()=>{setAddSupplyModal(true)}}
            startIcon={<AddBox />}
            sx={{
              marginBottom: 2,
              backgroundColor: "blue",
              color: "white",
              "&:hover": { backgroundColor: "#218838" },
            }}
          >
           Add Supplies
          </Button>
          <Button
            onClick={handleAddMarketlink}
            startIcon={<MoveToInbox />}
            sx={{
              marginBottom: 2,
              backgroundColor: "#28a745",
              color: "white",
              "&:hover": { backgroundColor: "#218838" },
            }}
          >
            Move Market-Linkage
          </Button>
          {/* {rowData.isVerified ? (
          <Typography
            sx={{
              marginBottom: 2,
              fontSize: "16px",
              fontWeight: "bold",
              color: "#00796b",
            }}
          >
            ✅ Verified
          </Typography>
        ) : (
          <Button
            onClick={handleVerify}
            startIcon={<CheckCircle />}
            sx={{
              marginBottom: 2,
              backgroundColor: "#00796b",
              color: "white",
              "&:hover": { backgroundColor: "#004d40" },
            }}
          >
            Verify
          </Button>
          )} */}
        </Box>
      </Box>

      {error && <p>{error}</p>}
      <Divider sx={{ marginBottom: 2 }} />
      <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
                Crop Production Details:
              </Typography>
      <div className="row">
      <div className="col-md-6">
      {rowData && (
        <>
        <div>
          <Typography><strong>Farmer Name:</strong> {rowData.farmerName}</Typography>
          <Typography><strong>Gender:</strong> {rowData.gender}</Typography>
          <Typography><strong>Caste:</strong> {rowData.caste}</Typography>
          <Typography><strong>PG Code:</strong> {rowData.pgCode}</Typography>
          <Typography><strong>Season Name:</strong> {rowData.seasonName}</Typography>
          {/* <p><strong>Seed Sowing Date:</strong> {rowData.seedSowingDate}</p> */}
            {/* <p><strong>cropProductionMasterId:</strong> {rowData.cropProductionMasterId}</p> */}

        </div>
        <div>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }} className="mt-2">
              Verification Details:
            </Typography>
          {verifiedBy?.verifierName && verifiedBy?.role ? (
            <Box sx={{ marginBottom: 2 }}>
            
            <Typography variant="body1"><strong>Last Verified By</strong></Typography>
            <Typography variant="body1"><strong>Name : </strong> {verifiedBy.verifierName || "Not Available"}</Typography>
            <Typography variant="body1"><strong>Role :</strong> {verifiedBy.role || "Not Available"}</Typography>
          </Box>
          ) : (
            <p>No verification data available</p>
          )}
        </div>
        </>
      )}
</div>
<div className="col-md-6">
  <h6 className="text-bold">Supplies Used:</h6>
  {usedsupplies?.supplies?.length > 0 || usedsupplies?.otherSupplies ? (
    <div className="row">
      {/* Group supplies by supplyType */}
      <div className="col-md-12">
        {Object.entries(
          usedsupplies.supplies?.reduce((acc, supply) => {
            if (!acc[supply.supplyType]) acc[supply.supplyType] = [];
            acc[supply.supplyType].push(supply.supplyName);
            return acc;
          }, {}) || {}
        ).map(([type, names]) => (
          <div key={type} className="mb-2">
            <strong>{type}:</strong>
            <ul className="m-0">
              {names.map((name, index) => (
                <li key={index}>{name}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Show other supplies under "PP Chemicals" */}
      {usedsupplies.otherSupplies && (
        <div className="col-md-12">
          <div className="mb-2">
            <strong>PP Chemicals:</strong>
            <div
              style={{
                wordWrap: "break-word",
                whiteSpace: "normal",
                padding: "5px",
                maxHeight: "100px",
                overflowX: "auto",
                overflowY: "auto",
                scrollbarWidth: "thin",
              }}
            >
              <ul className="m-0 p-0" style={{ listStyleType: "none" }}>
                <li>{usedsupplies.otherSupplies}</li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  ) : (
    <div className="mb-2">No supply used</div>
  )}
</div>

      </div>
      {loading ? (
        <p>Loading...</p>
      ) : productionData ? (
        <div style={{ height: 320, width: "100%" }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
            Production Item Details:
          </Typography>

          <DataGrid
  rows={productionData.map((data, index) => ({
    id: index,
    cropProductionMasterId: data.cropProductionMasterId,
    cropCuttingDate: data.cropCuttingDate,
    productionQuantity: data.productionQuantity,
    cultivatedArea: data.cultivatedArea,
    seedSowingDate: data.seedSowingDate,
    yield5x5: data.yield5x5,
    cropProductionId: data.cropProductionId,
    seedName: data.seedName,
    seedClass: data.seedClass,
    plannedArea: data.plannedArea,
    seedVariety: data.seedVariety,
    cropType: data.cropType,
    status:data.status,
    isInactive: data.isInactive || false, // Ensure the isInactive property is included
    cultivationDate: data.harvestingDate 
    ? new Date(data.harvestingDate).toLocaleDateString("en-GB") 
    : "NA",
    cropPlanId:data.cropPlanId
  }))}
  columns={[
    { field: "seedName", headerName: "Seed Name", flex: 70 },
    { field: "seedClass", headerName: "Seed Class", flex: 50 },
    { field: "seedVariety", headerName: "Seed Variety", flex: 70 },
    { field: "cropType", headerName: "Crop Type", flex: 70 },
    {
      field: "plannedArea",
      headerName: "Planned Area (in ha.)",
      flex: 70,
      valueFormatter: (params) =>
        params.value != null && !isNaN(params.value) ? `${params.value}` : "0",
    },
    {
      field: "cultivatedArea",
      headerName: "Cultivated Area (in ha.)",
      flex: 70,
      valueFormatter: (params) =>
        params.value != null && !isNaN(params.value) ? `${params.value}` : "0",
    },
    {
      field: "cultivationDate",
      headerName: "Harvesting Date",
      flex: 70,
      valueFormatter: (params) => params.value || "NA",
    },
    {
      field: "productionQuantity",
      headerName: "Production(in Qtl.)",
      flex: 90,
      valueFormatter: (params) =>
        params.value != null && !isNaN(params.value) ? `${params.value}` : "NA",
    },
    { field: "status", headerName: "Status", flex: 70 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 100,
      renderCell: (params) => {
        // Determine if buttons should be disabled based on productionQuantity
        const isProductionNA = 
          params.row.productionQuantity == null || 
          isNaN(params.row.productionQuantity) || 
          params.row.productionQuantity === "NA";
  
        const isActionsDisabled = params.row.status === "MarketLinkage" || params.row.isInactive;
  
        return (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            {/* Edit Button */}
            <Tooltip title="Edit">
              <span>
                <IconButton
                  onClick={() => handleEditClick(params.row)}
                  disabled={isActionsDisabled || isProductionNA} // Disable if productionQuantity is NA
                  sx={{ color: isActionsDisabled || isProductionNA ? "grey" : "blue" }}
                >
                  <Edit />
                </IconButton>
              </span>
            </Tooltip>
  
            {/* Delete Button */}
            <Tooltip title="Delete">
              <span>
                <IconButton
                  onClick={() => handleDeleteClick(params.row)}
                  disabled={isActionsDisabled}
                  sx={{ color: isActionsDisabled ? "grey" : "red" }}
                >
                  <Delete />
                </IconButton>
              </span>
            </Tooltip>
  
            {/* Market Button */}
            <Tooltip title="Market">
              <span>
                <IconButton
                  onClick={() => handleMarketClick(params.row)}
                  disabled={isActionsDisabled || isProductionNA} // Disable if productionQuantity is NA
                  sx={{ color: isActionsDisabled || isProductionNA ? "grey" : "green" }}
                >
                  <SiCoinmarketcap />
                </IconButton>
              </span>
            </Tooltip>
  
            {/* Add Button */}
            <Tooltip title="Add">
              <span>
                <IconButton
                  onClick={() => handleAddClick(params.row)}
                  disabled={!isProductionNA} 
                  sx={{ color: !isProductionNA ? "grey" : "purple" }}
                >
                  <Add />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        );
      },
    },
  ]}
  
  
  pageSize={5}
  disableSelectionOnClick
  pagination
  sx={{
    border: "1px solid #e0e0e0",
    "& .MuiDataGrid-columnHeaders": { backgroundColor: "#f5f5f5" },
    "& .MuiDataGrid-cell": { fontSize: 14 },
    "& .MuiDataGrid-row:hover": { backgroundColor: "#f5f5f5" },
  }}
/>

        </div>
      ) : (
        <Typography>No additional production data available.</Typography>
      )}
{/* ADD production details */}
 <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Add Production Quantity</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Production Quantity(qtl)"
            name="productionQuantity"
            value={formData.productionQuantity}
            onChange={handleInputChange}
            type="number"
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmitproduction} color="primary" variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this crop plan?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirm} color="primary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog open={openDialog} onClose={handleCancel}>
  <DialogTitle>Market Details</DialogTitle>
  <DialogContent>

  {selectedRow && (
      <Typography variant="body1">
        <strong>Production Quantity:</strong> {selectedRow.productionQuantity} kg
      </Typography>
    )}
   
      <FormControl
        fullWidth
        variant="outlined"
        margin="normal"
        style={{ backgroundColor: "#f5f5f5" }}
      >
        <InputLabel>Sale Type</InputLabel>
        <Select
          label="Sale Type"
          value={formData.marketTypeId} 
          onChange={(e) => {
            const selectedValue = Number(e.target.value);
      
            setFormData((prev) => ({
              ...prev,
              marketTypeId: selectedValue,
            }));

            setIsMandi(selectedValue === 2);
          }}

        >
          {saletypes.map((s) => (
            <MenuItem key={s.marketTypeId} value={s.marketTypeId}>
              {s.marketType}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
   
      <TextField
      fullWidth
      label="Location"
      name="location"
      value={formData.location}
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          location: e.target.value,
        }))
      }
      variant="outlined"
      margin="normal"
    />
    <TextField
      fullWidth
      label="Name"
      name="name"
      value={formData.name}
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          name: e.target.value,
        }))
      }
      variant="outlined"
      margin="normal"
    />

    <TextField
      fullWidth
      label="Sell Quantity"
      name="sellQuantity"
      value={formData.sellQuantity}
      onChange={handleSellQuantityChange}
      variant="outlined"
      margin="normal"
      required
      inputProps={{
        inputMode: "decimal", 
        pattern: "^[0-9]*\\.?[0-9]*$",
      }}
    />

    <TextField
      fullWidth
      label="Base Price"
      name="basePrice"
      value={formData.basePrice}
      onChange={(e) => {
        const value = e.target.value;
        if (/^[0-9]*\.?[0-9]*$/.test(value)) {
          handleChange(e);
        }
      }}
      variant="outlined"
      margin="normal"
      required
      inputProps={{
        inputMode: "decimal", 
        pattern: "^[0-9]*\\.?[0-9]*$", 
      }}
      helperText={error}
      error={!!error}
    />

    <TextField
      fullWidth
      label="Sale Price (Qtl)"
      name="salePrice"
      value={formData.salePrice}
      onChange={(e) => {
        const value = e.target.value;
        if (/^[0-9]*\.?[0-9]*$/.test(value)) {
          handleChange(e); 
        }
      }}
      variant="outlined"
      margin="normal"
      required
      inputProps={{
        inputMode: "decimal", 
        pattern: "^[0-9]*\\.?[0-9]*$",
      }}
      helperText={warning}
      error={!!warning}
    />

{remainingQuantity > 0 && (
        <>
          {/* Used TlSeed Field */}
          <TextField
            fullWidth
            label="Used TlSeed"
            name="tlSeed"
            value={formData.tlSeed}
            onChange={handleTlSeedChange}
            variant="outlined"
            margin="normal"
            required
            inputProps={{
              inputMode: "decimal",
              pattern: "^[0-9]*\\.?[0-9]*$",
            }}
          />

          {/* Use for Consumption Field */}
          <TextField
            fullWidth
            label="Use for Consumption"
            name="consumption"
            value={formData.consumption}
            onChange={handleConsumptionChange}
            variant="outlined"
            margin="normal"
            required
            inputProps={{
              inputMode: "decimal",
              pattern: "^[0-9]*\\.?[0-9]*$",
            }}
          />

          {/* <Typography variant="body2" color="textSecondary">
            Remaining for Consumption: {remainingForConsumption > 0 ? remainingForConsumption : 0} kg
          </Typography> */}
        </>
      )}
  </DialogContent>

  <DialogActions>
    <Button
      variant="contained"
      color="primary"
      sx={{
        fontWeight: "bold",
        fontSize: "14px",
        paddingX: 3,
        paddingY: 0.5,
        height: "40px",
        borderRadius: "20px",
        backgroundColor: "#1976d2",
        "&:hover": {
          backgroundColor: "#115293",
          boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.2)",
        },
        transition: "all 0.3s ease-in-out",
      }}
      onClick={handleSubmit}
    >
      Save
    </Button>
    <Button
      variant="outlined"
      color="secondary"
      onClick={handleCancel}
      sx={{
        fontWeight: "bold",
        fontSize: "14px",
        paddingX: 3,
        paddingY: 0.5,
        height: "40px",
        borderRadius: "20px",
        borderColor: "#f50057",
        color: "#f50057",
        "&:hover": {
          backgroundColor: "#ffe3ea",
          borderColor: "#c51162",
          color: "#c51162",
        },
        transition: "all 0.3s ease-in-out",
      }}
    >
      Cancel
    </Button>
  </DialogActions>
</Dialog>

      <Dialog
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Edit Crop Details</DialogTitle>
        <DialogContent>
          <form>
            {/* <TextField
              fullWidth
              margin="normal"
              label="Seed Sowing Date"
              type="date"
              value={selectedRow?.seedSowingDate || ""}
              onChange={(e) =>
                setSelectedRow({ ...selectedRow, seedSowingDate: e.target.value })
              }
              InputLabelProps={{ shrink: true }}
            /> */}

            
            <TextField
              fullWidth
              margin="normal"
              label="Cultivated Area (ha)"
              value={selectedRow?.cultivatedArea || ""}
              onChange={(e) =>
                setSelectedRow({ ...selectedRow, cultivatedArea: e.target.value })
              }
            />
           
            <TextField
              fullWidth
              margin="normal"
              label="Production Amount (Kg)"
              value={selectedRow?.productionQuantity || ""}
              onChange={(e) =>
                setSelectedRow({ ...selectedRow, productionQuantity: e.target.value })
              }
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditDialog(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSaveEdit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={addsupplymodal}
        onClose={() => {setAddSupplyModal(false); setSelectedSupplyTypes([]);}}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Add Supplies</DialogTitle>
        <DialogContent>
          <form>
            <FormControl fullWidth margin="normal">
            <InputLabel>Select Supply Type</InputLabel>
            <Select
              multiple
              value={Array.isArray(selectedSupplyTypes) ? selectedSupplyTypes : [selectedSupplyTypes]}
              onChange={handleSelectionChange}
              renderValue={(selected) => selected.map(id => supplyTypes.find(s => s.supplyTypeId === id)?.type).join(", ")}
              label="Select Supply Type"
            >
              {supplyTypes.map((supply) => (
                <MenuItem key={supply.supplyTypeId} value={supply.supplyTypeId}>
                  {supply.type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {Array.isArray(selectedSupplyTypes) && selectedSupplyTypes.includes(1) && (
            <TextField
              fullWidth
              margin="normal"
              label="Enter PP Chemicals"
              value={ppchemical}
              onChange={(e) => setPPchemical(e.target.value)}
            />
          )}

          {Array.isArray(selectedSupplyTypes) && selectedSupplyTypes.some(id => id !== 1) && (
            <FormControl fullWidth margin="normal">
            <InputLabel>Select Supply Type</InputLabel>
            <Select
              multiple
              value={Array.isArray(allselectedSupplies) ? allselectedSupplies : [allselectedSupplies]}
              onChange={handleAllSelectionSupplies}
              renderValue={(selected) => 
                selected
                  .map(id => supplyResponse.find(s => s.supplyId === id)?.supplyName)
                  .filter(Boolean) 
                  .join(", ")
              }
              label="Select Supply Type"
            >
              {supplyResponse.map((supply) => (
                <MenuItem key={supply.supplyId} value={supply.supplyId}>
                  {supply.supplyName} {/* Correct field */}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          )}
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {setAddSupplyModal(false); setSelectedSupplyTypes([]);}} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSaveAddSupplies} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>


    </Box>
  );
};

export default ChildProduction;
